import { ReactNode } from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { copyToClipboard } from '../../script';

function _Card(props: { title: string; content: ReactNode; isCopyable?: { data: string; label: string } }) {
    return (
        <div className="flex-1 rounded-lg p-4 flex flex-col gap-2 border border-[#F5F8FF] text-[#1C1D1F] min-w-[248px] max-md:min-w-[140px]">
            <div className="flex items-center gap-1">
                <label className="font-bold text-sm max-lg:text-xs opacity-50">{props.title}</label>
                {props.isCopyable && (
                    <IoCopyOutline
                        onClick={() => {
                            copyToClipboard(props.isCopyable?.data, props.isCopyable?.label);
                        }}
                        className="cursor-pointer w-4 h-4 transition-opacity hover:opacity-70 mb-1"
                    />
                )}
            </div>
            {props.content}
        </div>
    );
}

export default _Card;
